export function getInclusionsFromAgeList(
  ageList?: string | string[] | null,
): string[] {
  if (!ageList || ageList === null) {
    return []
  }

  const containsAdult = ageList.includes('Adult')
  const containsChild = ageList.includes('Child')
  const containsOlderAdult = ageList.includes('Older Adult')

  if (containsChild && containsAdult && containsOlderAdult) {
    return []
  } else if (containsChild && !containsAdult && !containsOlderAdult) {
    return ['Be younger than 18 years old']
  } else if (containsChild && containsAdult && !containsOlderAdult) {
    return ['Be younger than 65 years old']
  } else if (!containsChild && containsAdult && !containsOlderAdult) {
    return ['Be between 18 and 65 years old']
  } else if (!containsChild && containsAdult && containsOlderAdult) {
    return ['Be older than 18 years old']
  } else if (!containsChild && !containsAdult && containsOlderAdult) {
    return ['Be older than 65 years old']
  }

  return []
}
